import { withGiftVoucherInitialFormValues } from "../WithGiftVoucherFormItem"

export const getInitialValues = (courseWithEquipment: boolean, coursePrice: number) => ({
  student: {
    firstname: "",
    lastname: "",
    yearOfStudies: "",
    schoolRegion: "",
    school: "",
    email: ""
  },
  studentContact: {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    relationToStudent: ""
  },
  iSignUp: false,
  newsletterAgreement: false,
  ...withGiftVoucherInitialFormValues,
  ...(courseWithEquipment && {
    equipmentBuyFromOrganization: true,
    equipmentSendToAddress: ""
  }),
  coupon: undefined,
  referralSource: "",
  consent: false,
  wantInvoice: false,
  ...(coursePrice > 0 && {
    invoice: {
      name: "",
      email: "",
      street: "",
      city: "",
      zip: "",
      country: "CZ",
      registration_no: "",
      vat_no: ""
    }
  })
})
